import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import styles from './styles'

const SectionHeading = ({ className, title, count, countDisplayed }) => (
  <h4 className={cx(styles.title, className)}>
    {`${title} `}
    {count && (
      <span className={styles.count}>
        ({countDisplayed} of {count})
      </span>
    )}
  </h4>
)

SectionHeading.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  count: PropTypes.number,
  countDisplayed: PropTypes.number,
}

export default SectionHeading
